import type { SVGProps } from "react";
import { memo } from "react";

import { cn } from "@btnet/utilities-core";

import "./Icon.less";
import type { IIconProps } from "./Icon.types";

const SvgIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 32 32"
    {...props}
  >
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M16.905 6.574a1 1 0 0 0-1.81 0L9.473 18.523a1 1 0 0 0-.05.105l-2.328 4.946a1 1 0 1 0 1.81.852L10.988 20h10.025l2.082 4.426a1 1 0 0 0 1.81-.852zM20.071 18l-4.07-8.651L11.928 18z"
      clipRule="evenodd"
    />
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M3 2a1 1 0 0 0-1 1v26a1 1 0 0 0 .031.25A1 1 0 0 0 3 30h26a1 1 0 0 0 1-1V3a1 1 0 0 0-1-1zm25 2H4v24h24z"
      clipRule="evenodd"
    />
  </svg>
);
const SvgIconTextABox = ({
  testid,
  size = "md",
  className,
  ariaLabel,
  innerRef,
  ...props
}: IIconProps) => {
  const ariaVisibilityProp = ariaLabel
    ? {
        "aria-label": ariaLabel,
      }
    : {
        "aria-hidden": true,
      };
  return (
    <div
      data-testid={testid}
      className={cn("icon bds-icon", className, {
        ["bds-icon-" + size]: size,
        ["icon-" + size]: size,
      })}
      ref={innerRef}
      {...props}
    >
      <SvgIcon role="img" fill="none" {...ariaVisibilityProp} />
    </div>
  );
};
const Memo = memo(SvgIconTextABox);
export default Memo;
